import React from "react";
import { observer } from "mobx-react-lite";
import store from "store";
import styled from "styled-components";

const EleDiv = styled.div`
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${(props) => (props.isDark ? "#fff" : "#333")};
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
`;

export default observer(function Foot() {
  const {isDark} = store.app;

  return (
    <EleDiv
      isDark={isDark}
    >{`© ${new Date().getFullYear()} Spikex. All Rights Reserved.`}</EleDiv>
  );
})
